interface SectionData {
  sectionTitle: string;
  subTitleText?: string;
}

interface SectionListProps {
  data: SectionData[] | SectionData;
  className?: string;
}

const SectionList: React.FC<SectionListProps> = ({ data, className = "" }) => {
  const normalizeData = Array.isArray(data) ? data : [data];

  const processHtml = (html: string): string[] => {
    if (!html) return [];
    let plainText = "";
    let inTag = false;
    let tagContent = "";

    for (const char of html) {
      if (!inTag && char === "<") {
        inTag = true;
        tagContent = "";
        continue;
      }

      if (inTag) {
        if (char === ">") {
          const normalizedTag = tagContent.trim().toLowerCase();
          if (normalizedTag.startsWith("br")) {
            plainText += "\n";
          }
          inTag = false;
          continue;
        }

        tagContent += char;
        continue;
      }

      plainText += char;
    }

    return plainText
      .split("\n")
      .map((line) => line.trim())
      .filter(Boolean);
  };

  return (
    <div data-testid="section-list" className={`flex flex-col ${className}`}>
      {normalizeData.map((item, index) => (
        <div className="mb-3" key={`section-${item.sectionTitle}`}>
          <h3 className="mb-2 text-sm leading-6 font-medium md:mb-0">{item.sectionTitle}</h3>
          {item.subTitleText &&
            processHtml(item.subTitleText).map((line) => (
              <p
                key={line}
                className="text-[10px] leading-4"
                style={{ WebkitFontSmoothing: "auto", MozOsxFontSmoothing: "auto" }}
              >
                {line}
              </p>
            ))}
        </div>
      ))}
    </div>
  );
};

export default SectionList;
